




















































import camelCase from 'lodash/camelCase'
import { mapGetters } from 'vuex'
import ListFilters from '@/components/ListFilters.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import DropdownFilter from '@/components/DropdownFilter.vue'
import AddressTypeAhead from '../../marketplace/components/AddressTypeAhead.vue'
import { ORDERED_REQUIRED_ACTIONS } from '../constants'
import {
  MarketplaceLocation,
  prepareLocationData,
  prepareSelectedLocation
} from '../../marketplace/marketplace-location'

export default {
  components: { ListFilters, DateRangePicker, DropdownFilter, AddressTypeAhead },
  computed: {
    ...mapGetters(['myTransportsFilters']),
    initialFilterValues() {
      const {
        reference,
        pickupRangeStart,
        pickupRangeEnd,
        pickupPlaceId,
        dropOffPlaceId,
        pickupLocationName,
        dropOffLocationName,
        requiredActions
      } = this.myTransportsFilters
      return {
        reference,
        pickupRange: {
          pickupRangeStart,
          pickupRangeEnd
        },
        pickupLocation: prepareLocationData(pickupPlaceId, pickupLocationName),
        dropOffLocation: prepareLocationData(dropOffPlaceId, dropOffLocationName),
        requiredActions
      }
    },
    requiredActionsOptions() {
      return ORDERED_REQUIRED_ACTIONS.reduce((obj, action) => {
        obj[action] = this.$t(`myTransports.transportRow.actions.${camelCase(action)}`)
        return obj
      }, {})
    }
  },
  methods: {
    prepareLocation(location: MarketplaceLocation): Array<MarketplaceLocation> {
      return prepareSelectedLocation(location)
    }
  }
}
